export default "__VITE_ASSET__caeb3b77__"